import 'react';
import classnames from 'classnames';
import styled from 'styled-components';
import { selectFromTheme } from '@thisisbud/sc-utils';
import { jsx } from 'react/jsx-runtime';

let _ = t => t,
  _t;
const padderClassName = 'bui-padder';

// eslint-disable-next-line @typescript-eslint/naming-convention
const StyledPadder = /*#__PURE__*/styled.div.withConfig({
  displayName: "StyledPadder",
  componentId: "sc-juke0w-0"
})(_t || (_t = _`
  padding: ${0};
  box-sizing: border-box;

  @media (min-width: ${0}) {
    padding: ${0};
  }
`), selectFromTheme('paddingPadderDefault'), selectFromTheme('breakpointWide'), selectFromTheme('paddingPadderWide'));

/**
 * A component that renders its children with padding.
 *
 * @remarks By default the component renders as a `div` tag, but any tag or component can be used via the `as` prop
 * @param props - The component props
 * @public
 *
 * @example
 * ```javascript
 * import * as React from 'react'
 * import { Padder } from '@thisisbud/bui-react-padder'
 *
 * function Example() {
 *   return <Padder>The quick brown fox jumps over the lazy dog</Padder>
 * }
 * ```
 */
function Padder(props) {
  const {
    as,
    children,
    className,
    role
  } = props;
  return /*#__PURE__*/jsx(StyledPadder, {
    as: as,
    className: classnames(padderClassName, className),
    role: role,
    children: children
  });
}
Padder.displayName = 'Padder';

export { Padder, padderClassName };
